import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';
import { CartridgesOverviewComponent } from './cartridges-overview/cartridges-overview.component';
import { TranslocoModule } from '@jsverse/transloco';
import { SharedUiInfoCalloutModule } from '@markant-platform/shared/ui-info-callout';
import { BackofficeFeatureCartridgesOverviewModuleRoutingModule } from './backoffice-feature-cartridges-overview-routing.module';
import { SharedUiFilterModule } from '@markant-platform/shared/ui-filter';
import { SharedTableFeatureModule } from '@markant-platform/shared/table/feature';
import { FormsModule } from '@angular/forms';
import { CartridgeDataAccessModule } from '@markant-platform/cartridge/data-access';
import { ConcatPipe } from '@markant-platform/shared/util-pipes';
import { UiPageHeaderComponent } from '@markant-platform/shared/ui-components';

@NgModule({
  imports: [
    CommonModule,
    MarkantElementsModule,
    SharedUiInfoCalloutModule,
    TranslocoModule,
    BackofficeFeatureCartridgesOverviewModuleRoutingModule,
    SharedUiFilterModule,
    SharedTableFeatureModule,
    FormsModule,
    CartridgeDataAccessModule,
    ConcatPipe,
    UiPageHeaderComponent,
  ],
  declarations: [CartridgesOverviewComponent],
})
export class BackofficeFeatureCartridgesOverviewModule {}
